<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="unnumbered-1">
<div class="heading heading-with-title heading-without-image" id="unnumbered-1-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">Day 1</h1>
</div>
<h2 class="subtitle">Tuesday, 20th March</h2>
</div>
</div>
</div>
<div class="text" id="unnumbered-1-text">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// day1.vue?381f98a1